import { UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../constants/experiments';
import { IOfferDiscount } from '../../types/results';
import { PriceDiscount } from '../PriceDiscount';
import { experimentToggle } from '../experimentToggle';

interface IOfferHeaderProps {
  price: string;
  discount?: IOfferDiscount;

  isRedesignExperimentActive: boolean;
  isBooked: boolean;
}

export const OfferHeader: React.FC<IOfferHeaderProps> = ({ price, discount, isRedesignExperimentActive, isBooked }) => {
  return (
    <div className={isBooked ? styles['price--booked'] : styles['price']}>
      {!discount &&
        /**
         * @todo experimentToggle - временное решение, удалить после завершения эксперимента aud_mobile_bx585_saved_search_favorites_merge
         */
        experimentToggle(
          isRedesignExperimentActive,
          BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT,
          price,
          <UIHeading4 color={isBooked ? 'text-secondary-default' : 'text-primary-default'}>{price}</UIHeading4>,
        )}
      {discount && (
        <PriceDiscount oldPrice={discount.oldPrice} newPrice={discount.newPrice} percent={discount.percent} />
      )}
    </div>
  );
};
